export default __webpack_public_path__ + "media/images/react_icons/checkout_arrow_right-aa5aff4cbb1de87b47baf1c7afd925ee.svg";